var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2384_8278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.65357 -0.000976562C7.51086 -0.000976562 7.36957 0.0275398 7.238 0.0828981C7.10728 0.137912 6.98877 0.218334 6.88937 0.31949L1.00523 6.17507C0.961543 6.21854 0.92985 6.27258 0.913236 6.33192L0.0132356 9.54622C-0.0215537 9.67043 0.0133779 9.80379 0.104613 9.89508C0.195849 9.98629 0.3292 10.0212 0.453448 9.98643L3.66774 9.08644C3.72708 9.06979 3.78111 9.03808 3.82459 8.99444L9.68007 3.11036L9.68107 3.1094C9.781 3.00999 9.86036 2.89184 9.91457 2.76169C9.969 2.63114 9.997 2.49109 9.997 2.34965C9.997 2.20821 9.969 2.06816 9.91457 1.9376C9.86036 1.80746 9.781 1.68929 9.68107 1.58989L9.68007 1.58894L8.4185 0.320236C8.319 0.218729 8.20022 0.138047 8.06914 0.0828981C7.93757 0.0275398 7.79629 -0.000976562 7.65357 -0.000976562Z",
    fill: "#0092CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2384_8278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg12);
export default __webpack_public_path__ + "static/media/svg12.f6e3049fb5e5d7813d3c40247e614654.svg";
export { ForwardRef as ReactComponent };